import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { MockDataManager } from './mock-data-manager'
import { Database } from 'lucide-react'
import { apiModeManager } from '@/lib/api-mode-manager'

export function MockDataToggle() {
  const [isOpen, setIsOpen] = useState(false)

  // Only show in development mode and when mock is enabled
  if (import.meta.env.PROD || !apiModeManager.shouldUseMock()) {
    return null
  }

  return (
    <>
      <div className="fixed bottom-20 right-4 z-40">
        <Button
          onClick={() => setIsOpen(true)}
          className="bg-blue-600 hover:bg-blue-700 text-white shadow-lg flex items-center gap-2"
          size="sm"
        >
          <Database className="w-4 h-4" />
          Mock 數據管理
        </Button>
      </div>
      
      <MockDataManager isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  )
}